// رمز تأكيد الحذف
// كان رقم ثابت (123) متكتوب في البرنامج. دلوقتي رمز سري بيتحدد في إعدادات السيرفر (DELETE_CODE)،
// والسيرفر هو اللي بيتأكد منه. الشاشة بتسأل عنه زي الأول قبل أي حذف وبتبعته مع الطلب.

let last = { code: '', at: 0 };

// بيسأل المستخدم عن الرمز. بيرجّع الرمز، أو null لو داس إلغاء.
export const askDeleteCode = (message) => {
    const code = window.prompt(message || 'تأكيد الحذف مطلوب. اكتب رمز تأكيد الحذف للمتابعة:');
    if (code === null) return null;
    last = { code: String(code).trim(), at: Date.now() };
    return last.code;
};

// الرمز اللي اتكتب من لحظات (عشان الشاشة متسألش مرتين لنفس عملية الحذف)
export const recentDeleteCode = (withinMs = 15000) => (last.code && Date.now() - last.at < withinMs ? last.code : '');

export const deleteHeaders = () => ({ 'X-Delete-Confirm': recentDeleteCode(60000) });

// التأكد من الرمز على السيرفر من غير حذف (للشاشات اللي بتأكد قبل ما تبدأ العملية)
export const checkDeleteCode = async (code) => {
    try {
        const r = await fetch('/api/session/check-delete-code', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: String(code || '').trim() })
        });
        const data = await r.json().catch(() => ({}));
        if (data.ok) last = { code: String(code).trim(), at: Date.now() };
        return !!data.ok;
    } catch {
        return false;
    }
};

export const isDeleteCodeError = (status, data) => status === 403 && /تأكيد الحذف/.test(String(data?.error || ''));
